// extracted by mini-css-extract-plugin
module.exports = {"carousel":"HeroQuiz_carousel__KX7uR","pen5453Variant":"HeroQuiz_pen5453Variant__AkLCA"};